import {ComponentType, Suspense} from "react";
import {LoadingScreen} from "../ui";

export const Loadable = <P extends object>(Component: ComponentType<P>) => {
  return (props: P) => (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};
